import React from 'react'
import TaxiBottomNavigation from '../../Component/TaxiBottomNavigation/TaxiBottomNavigation'
import BurgerMenuTitle from './../../Component/BurgerMenuTitle/BurgerMenuTitle';
import TaxiTab from '../../Component/Tabs/TaxiTabs/TaxiTab';

const TaxiPanelLayout = () => {

  return (
    <div style={{padding:'2.5rem 0'}}>
      <BurgerMenuTitle title={"تاکسی"} />
      <TaxiTab/>
      <TaxiBottomNavigation/>
    </div>
  )
}

export default TaxiPanelLayout